var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelloWidgetTemplate',_vm._b({},'HelloWidgetTemplate',_vm.computedProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }